module.exports = __webpack_public_path__ + "static/media/dev2.4eb06b09.jpg";